exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mm-button[data-v-45defd51]{display:inline-block;background:transparent;cursor:pointer;color:#1f1f1f;margin:0 .32rem 0 0}.mm-button .asset-img[data-v-45defd51]{height:.19rem;position:relative;top:.01rem}.mm-logo[data-v-45defd51]{height:.26rem;margin-right:.16rem;position:relative;top:.03rem}.mm-text[data-v-45defd51]{position:relative;top:.02rem}", ""]);

// exports
